import React from 'react';
import { renderizarMensagemWhatsApp } from '../../../Utils/renderizarMensagemWhatsApp'; // ajuste o caminho certo
import "./MensagemRespondidaPreview.css";

const MensagemRespondidaPreview = ({ mensagem }) => {
    if (!mensagem) return null;

    const tipo = mensagem.logConversasWhatsAppTipo?.toLowerCase();

    return (
        <div className="mensagem-respondida-preview">
            <div className="mensagem-respondida-barra" />

            <div className="mensagem-respondida-conteudo">
                {mensagem.logConversasWhatsAppMediaId && tipo === 'image' && (
                    <span>📷 Imagem</span>
                )}

                {mensagem.logConversasWhatsAppMediaId && tipo === 'audio' && (
                    <span>🎤 Áudio</span>
                )}

                {mensagem.logConversasWhatsAppMediaId && tipo === 'document' && (
                    <span>📄 Documento</span>
                )}

                {!mensagem.logConversasWhatsAppMediaId && (
                    <span>{renderizarMensagemWhatsApp(mensagem.logConversasWhatsAppMensagem)}</span>
                )}
            </div>
        </div>
    );
};


export default MensagemRespondidaPreview;
